import { AsmSearchViewId } from '../models/asm-search-view-id';
import { AsmSearchType } from '../models/asm-search-type';
import { SolViewId, TypeService, ViewService } from '@sol/components';

export function provideAsmSearchViews(viewService: ViewService, typeService: TypeService): void {
  typeService.addType(AsmSearchType.tagLabel);
  viewService.addView(
    AsmSearchType.tagLabel,
    'edit',
    AsmSearchViewId.tagLabelEdit,
    () =>
      import('../components/view/asm-view-edit-tag-label/asm-view-edit-tag-label.component').then(
        m => m.AsmViewEditTagLabelComponent,
      ),
    true,
  );
  viewService.addView(
    AsmSearchType.tagLabel.array,
    'edit',
    AsmSearchViewId.tagLabelEdit,
    () =>
      import('../components/view/asm-view-edit-tag-label/asm-view-edit-tag-label.component').then(
        m => m.AsmViewEditTagLabelComponent,
      ),
    true,
  );
  viewService.addView(
    AsmSearchType.tagLabel,
    'read',
    SolViewId.tag,
    () =>
      import('../components/view/asm-view-read-tag-label/asm-view-read-tag-label.component').then(
        m => m.AsmViewReadTagLabelComponent,
      ),
    true,
  );
}
